<template>
<div class="pageFooter">
  <hr />
  <div class="pageFooterContent">
    <CopyrightNotice />
    <SocialMediaIconBar />
  </div>

  <div class="contact" >
      Contact: <a href="mailto:eatsonfeetsmail@gmail.com">eatsonfeetsmail@gmail.com</a>
  </div>
</div>
</template>
<script>
import CopyrightNotice from './CopyrightNotice'
import SocialMediaIconBar from './SocialMediaIconBar'

export default {
  name: 'PageFooter',
  components: { CopyrightNotice, SocialMediaIconBar }
}
</script>
<style lang="scss" scoped>
.pageFooter {
  margin-top: 50px;
}

.pageFooterContent {
  margin-top: 50px;
  display: flex;
  flex-direction:row;
  justify-content: space-between;
}

.contact {
  clear: both;
  width: 100%;
  font-size: .8em;
}
</style>
